import bugsnag from '@bugsnag/js';

import { BUGSNAG_API_KEY, BUGSNAG_RELEASE_STAGE } from '../env';
import {
  errorClassToSeverityMapping, errorClassToGroupMapping, ignoreErrorClasses, ignoreErrorMessages,
} from './bugsnag-client-common';


let _store; // eslint-disable-line no-underscore-dangle

const beforeSend = (report) => {
  if (ignoreErrorClasses.includes(report.errorClass)
  || ignoreErrorMessages.includes(report.errorMessage)
  ) {
    return false;
  }

  if (_store) {
    report.updateMetaData('appState', JSON.parse(JSON.stringify(_store.getState())));
  }

  Object.keys(errorClassToSeverityMapping).forEach((severity) => {
    const errorClasses = errorClassToSeverityMapping[severity];
    if (errorClasses.includes(report.errorClass)) {
      report.severity = severity; // eslint-disable-line no-param-reassign
    }
  });

  Object.keys(errorClassToGroupMapping).forEach((groupingHash) => {
    const errorClasses = errorClassToGroupMapping[groupingHash];
    if (errorClasses.includes(report.errorClass)) {
      report.groupingHash = groupingHash;// eslint-disable-line no-param-reassign
      // report.groupingHash = context;
    }
  });

  return true;
};

const bugsnagClient = bugsnag({
  apiKey: BUGSNAG_API_KEY,
  appVersion: __VERSION__,
  releaseStage: BUGSNAG_RELEASE_STAGE,
  collectUserIp: false,
  notifyReleaseStages: ['ci', 'staging', 'production'],
  beforeSend,
});

console.log('buildTimestamp', __VERSION__);
console.log('__DEV__', __DEV__);

export const connectToStore = (store: Object) => {
  _store = store;
};

export default bugsnagClient;
